import { Doctor, DoctorSchema } from "../types/doctor";
import { TimeSlot, TimeSlotSchema } from "../types/timeslot";
import { get } from "../lib/api";
import { ClinicIds } from "../store/ClinicStore";

export const getDoctorsForAptType = async (clinicIds: ClinicIds, appointmentTypeId: string): Promise<{doctors: Doctor[], first_time_slots: Record<string, TimeSlot>}> => {
    const docsForAptData = (await get('doctors/for-appointment-type', {
        clinic_group_crm: clinicIds.groupCRM,
        user_fk: clinicIds.userFK,
        location_id: clinicIds.locationId,
        appointment_type_id: appointmentTypeId
    })) as {doctors: Record<string, any>[], first_time_slots: Record<string, any>}
    // Convert appt_types to strings
    for (const doctor of docsForAptData.doctors) {
        if (!doctor.appt_types) {
            continue;
        }
        if (typeof doctor.appt_types[0] !== "string") {
            doctor.appt_types = doctor.appt_types.map((appt_type) => appt_type.toString())
        }
    }
    const doctors = DoctorSchema.array().parse(docsForAptData.doctors);
    const first_time_slots: Record<string, TimeSlot> = {};
    for (const doc_id in docsForAptData.first_time_slots) {
        first_time_slots[doc_id] = TimeSlotSchema.parse(docsForAptData.first_time_slots[doc_id])
    }
    return {
        doctors,
        first_time_slots
    }
}